export const defaultSettings = {
  title: '易缆网企业后台',
  logo: 'logo.ico',
  token: {
    key: 'token'
  },
}